import { AppErrorRedux } from '@/interfaces/error';

export const SET_ERROR = 'error/SET_ERROR' as const;
export const CLEAR_ERROR = 'error/CLEAR_ERROR' as const;

export const setError = (payload: AppErrorRedux) => ({ type: SET_ERROR, payload });

export const clearError = () => ({ type: CLEAR_ERROR });
